export default __webpack_public_path__ + "b641443f6b60cef093e2c963be3f4f81.png";